export const SUBMENU_CLOSE_DELAY = 150;
export const ICON_SIZE = 16;
